import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";
// Components

//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";
import Preloader from "../../components/Preloader/Preloader";
import MUIDataTable from "mui-datatables";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #59b259",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#c1c3d8",
    display: "none",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "rgba(89, 178, 89, 0.09)",
    padding: "1rem",
    border: "1.5px solid #59b259",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #59b259",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
});

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {
        root: {
          "&:nth-child(1)": {
            width: "100%",
          },
          "&:nth-child(2)": {
            width: 180,
          },
          "&:nth-child(3)": {
            width: 120,
          },
          "&:nth-child(4)": {
            width: 150,
          },
          "&:nth-child(5)": {
            width: 180,
          },
        },
      },
    },
  });

const PurchaseOrderWholesaleView = () => {
  const { pono, branchidno } = useParams();
  const classes = useStyles();
  const [supplierInfo, setSupplierInfo] = useState([]);
  const [items, setItems] = useState([]); //data to display in PO table
  const [shipTotal, setShipTotal] = useState(0);
  const [notes, setNotes] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);
  const [totalCount, setTotalCount] = useState(null);

  let history = useHistory();

  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  const data = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "view_promo_details_wholesale", {
        params: {
          pono: pono,
          jc_u_idno: branchidno,
        },
      })
      .then((res) => {
    

        // setItems(res.data.data[0][1].po_details);
        setSupplierInfo(res.data.data[0]);
        axios
          .get(process.env.REACT_APP_API_URL + "view_promo_details_package", {
            params: {
              pono: pono,
              jc_u_idno: branchidno,
            },
          })
          .then((res) => {
            const totalItems = res.data.data.reduce(
              (sum, i) => sum + (Number(i.qty) || 1),
              0
            );
                setTotalCount(totalItems);
            setItems(() => {
            const merged = Object.values(
              res.data.data.reduce((acc, item) => {
                if (acc[item.id]) {
                  acc[item.id].qty += 1;
                } else {
                  acc[item.id] = {
                    ...item,
                    qty: 1, // add 1 for qty
                  };
                }
                return acc;
              }, {})
            );

            return merged;
          });


            // const mappedData = res.data.data.map((item) => ({
            //   qty: 1,
            //   description: item.description,
            // }));
            // setItems(mappedData);
            // setItems(res.data.data);
            // setItems([
            // 	...items,
            // 	{
            // 	  qty: 1,

            // 	},
            //       ]);
            // setItems(res.data.data[0].description);
            // setSupplierInfo(res.data.data[0]);
            // setShipTotal(res.data.data[0][0].supplier_details.shipping);
            // setNotes(res.data.data[0][0].supplier_details.notes);
            setDataLoaded(true);
          })
          .catch((error) => {
            console.log(error);
            setDataLoaded(true);
          });
        setDataLoaded(true);
      })
      .catch((error) => {
        console.log(error);
        setDataLoaded(true);
      });
  };
  const columns = [
    {
      name: "description",
      label: "Name",
      options: {
        //filter: false,
        // display: "excluded",
      },
    },

    {
      name: "qty",
      label: "Qty",
      value: 1,
    },
  ];

  const options = {
    //hide toolbar functions
    toolbar: false,
    filter: false,
    viewColumns: false,
    search: false,
    download: false,
    print: false,
    csv: false,
    // filterType: "dropdown",
    selectableRows: "none",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    // tableBodyHeight,
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <LoyaltyTwoTone />
        </div>
        <NavLink to={"/purchases"}>
          <h4 style={{ color: "#339933" }}>Purchases</h4>
        </NavLink>
        <ArrowForwardIosIcon fontSize="small" color="disabled" />
        <NavLink
          to={"/purchases/purchases-order-wholesale-transaction-history"}
        >
          <h4 style={{ color: "#339933" }}>Purchase Order Wholesale Set Transaction History</h4>
        </NavLink>
        <ArrowForwardIosIcon fontSize="small" color="disabled" />
        <h4>Purchase Order Wholesale Set #{pono}</h4>
      </div>
      <div className="page-container">
        <Card className={classes.card}>
          <div className={classes.cardHeader}>
            <Grid container spacing={0} style={{ justifyContent: "flex-end" }}>
              <Grid item xs={12}>
                <div className={classes.subTitle}>Transaction Details</div>
              </Grid>
              <Grid item xs={2} style={{ textAlign: "right" }}>
                {/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
              </Grid>
              <Grid item xs={2} className={classes.buttonContainer}>
                {/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
              </Grid>
            </Grid>
          </div>

          <CardContent>
            <div className={classes.infoContainer}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4} className={classes.infoTitle}>
                  Date:
                </Grid>
                <Grid item xs={12} sm={8} className={classes.infoContent}>
                  {supplierInfo.trandate || "Date"}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4} className={classes.infoTitle}>
                  ID No:
                </Grid>
                <Grid item xs={12} sm={8} className={classes.infoContent}>
                  {supplierInfo.idno || "-"}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4} className={classes.infoTitle}>
                  Account Type:
                </Grid>
                <Grid item xs={12} sm={8} className={classes.infoContent}>
                  {supplierInfo.atype || "Type"}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4} className={classes.infoTitle}>
                  Account Type Name:
                </Grid>
                <Grid item xs={12} sm={8} className={classes.infoContent}>
                  {supplierInfo.packagesalestype || "Purchased From"}
                </Grid>
              </Grid>
              {totalCount && (<Grid container spacing={3}>
                <Grid item xs={12} sm={4} className={classes.infoTitle}>
                  Set Count:
                </Grid>
                <Grid item xs={12} sm={8} className={classes.infoContent}>
                  {totalCount|| "Count"}
                </Grid>
              </Grid>)}

              <Grid container spacing={3}>
                <Grid item xs={12} sm={4} className={classes.infoTitle}>
                  Wholesale Set Price:
                </Grid>
                <Grid item xs={12} sm={8} className={classes.infoContent}>
                  {supplierInfo.curcode || "curcode"}{" "}
                  {supplierInfo.amount || "curcode"}
                </Grid>
              </Grid>
            </div>
            {!dataLoaded ? (
              <Preloader />
            ) : (
              <MuiThemeProvider theme={getMuiTheme()}>
                <MUIDataTable
                  data={items}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
              // <div>render table here</div>
            )}
            {/* 	
								<div style={{textAlign:"right"}}className={classes.infoTotalItem}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "+ numeral(poTotal).format('0,0.00')}
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(grandTotal).format('0,0.00')}
								</div>	
							</div>
						</div>*/}
          </CardContent>
        </Card>

        {/* <div className={classes.buttonContainer}>
					<Button variant="contained">Back</Button> 
					<Button variant="contained" color="primary" onClick={approve_po}>
						Approve
					</Button>
				</div> */}
      </div>
    </div>
  );
};

export default PurchaseOrderWholesaleView;
